import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import annotation, { initialState as annotationInitialState, } from './annotation';
import openInMobileVisible from './openInMobile';
import clipboard from './clipboard';
import code from './code';
import comment from './comment';
import device from './device';
import deviceDetection from './deviceDetection';
import devTools from './devTools';
import downloadAssets from './assetDownload';
import grid from './grid';
import handoff from './handoff';
import hotspots from './hotspot';
import hoverStack from './hover';
import imagePreloading from './imagePreloading';
import layoutOverlay from './layoutOverlay';
import overlay from './overlay';
import password from './password';
import player from './player';
import project from './project';
import replay from './replay';
import screen from './screen';
import scrollContainer from './scrollContainer';
import user from './user';
var reducers = combineReducers({
    // Not sure how to define an initial state when using reduceReducers o.O
    openInMobileVisible: openInMobileVisible,
    annotation: function (state) {
        if (state === void 0) { state = annotationInitialState; }
        return state;
    },
    clipboard: clipboard,
    code: code,
    comment: comment,
    device: device,
    deviceDetection: deviceDetection,
    downloadAssets: downloadAssets,
    grid: grid,
    handoff: handoff,
    hotspots: hotspots,
    hoverStack: hoverStack,
    imagePreloading: imagePreloading,
    layoutOverlay: layoutOverlay,
    overlay: overlay,
    password: password,
    player: player,
    project: project,
    replay: replay,
    screen: screen,
    scrollContainer: scrollContainer,
    user: user,
});
export default reduceReducers(reducers, annotation, devTools);
